import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { SearchInterface } from 'src/shared/types/entities/search-interface'

export const createSearch = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): SearchInterface => {
  const entity = {
    ...generateBaseEntity(EntityTypeEnum.Search, parentId, masterBlockId),
    type: EntityTypeEnum.Search,
    dropdown: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 10px 8px 0px #0000000A',
      margin: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: 0,
        marginRight: 0,
      },
      border: {
        width: 1,
        style: BorderStyleEnum.solid,
        color: '#E5E7EB',
        radius: 10,
        type: BorderTypeEnum.fullBorder,
      },
    },
    item: {
      padding: {
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
      },
    },
    seeMore: {
      fontSize: 12,
      alignSelf: 'flex-start',
      color: '#00A0FF',
      fontWeight: '700',
      padding: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
    itemTitle: {
      fontSize: 14,
      textAlign: 'left',
      color: '#1F2937',
    },
    itemText: {
      fontSize: 12,
      textAlign: 'left',
      color: '#6B7280',
    },
    input: {
      fontSize: 15,
      textAlign: 'left',
      color: '#6B7280',
      padding: {
        paddingBottom: 10,
        paddingLeft: 12,
        paddingRight: 50,
        paddingTop: 10,
      },
      backgroundColor: '#FFFFFF',
      border: {
        width: 1,
        style: BorderStyleEnum.solid,
        color: '#E5E7EB',
        radius: 10,
        type: BorderTypeEnum.fullBorder,
      },
    },
  }
  return entity as SearchInterface
}

export const getSearchFontProperties = (entity: SearchInterface) => {
  const fontProperties = []
  if (entity.itemTitle.fontFamily) {
    fontProperties.push({
      fontFamily: entity.itemTitle.fontFamily,
      fontStyle: entity.itemTitle.fontStyle,
      fontWeight: entity.itemTitle.fontWeight,
    })
  }

  if (entity.itemTitle.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.itemTitle.mobileFontFamily,
      fontStyle: entity.itemTitle.mobileFontStyle,
      fontWeight: entity.itemTitle.mobileFontWeight,
    })
  }

  if (entity.itemText.fontFamily) {
    fontProperties.push({
      fontFamily: entity.itemText.fontFamily,
      fontStyle: entity.itemText.fontStyle,
      fontWeight: entity.itemText.fontWeight,
    })
  }

  if (entity.itemText.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.itemText.mobileFontFamily,
      fontStyle: entity.itemText.mobileFontStyle,
      fontWeight: entity.itemText.mobileFontWeight,
    })
  }

  if (entity.seeMore.fontFamily) {
    fontProperties.push({
      fontFamily: entity.seeMore.fontFamily,
      fontStyle: entity.seeMore.fontStyle,
      fontWeight: entity.seeMore.fontWeight,
    })
  }

  if (entity.seeMore.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.seeMore.mobileFontFamily,
      fontStyle: entity.seeMore.mobileFontStyle,
      fontWeight: entity.seeMore.mobileFontWeight,
    })
  }

  return fontProperties
}

export const getSearchCustomFontProperties = (entity: SearchInterface) => {
  const fontProperties = []

  if (entity.itemTitle.fontFamily && entity.itemTitle.fontFileId) {
    fontProperties.push({
      fontFamily: entity.itemTitle.fontFamily,
      fontFileId: entity.itemTitle.fontFileId,
    })
  }
  if (entity.itemTitle.mobileFontFamily && entity.itemTitle.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.itemTitle.mobileFontFamily,
      fontFileId: entity.itemTitle.mobileFontFileId,
    })
  }

  if (entity.itemText.fontFamily && entity.itemText.fontFileId) {
    fontProperties.push({
      fontFamily: entity.itemText.fontFamily,
      fontFileId: entity.itemText.fontFileId,
    })
  }
  if (entity.itemText.mobileFontFamily && entity.itemText.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.itemText.mobileFontFamily,
      fontFileId: entity.itemText.mobileFontFileId,
    })
  }

  if (entity.seeMore.fontFamily && entity.seeMore.fontFileId) {
    fontProperties.push({
      fontFamily: entity.seeMore.fontFamily,
      fontFileId: entity.seeMore.fontFileId,
    })
  }
  if (entity.seeMore.mobileFontFamily && entity.seeMore.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.seeMore.mobileFontFamily,
      fontFileId: entity.seeMore.mobileFontFileId,
    })
  }

  return fontProperties
}
